import { getTestIds } from 'seagull/utils/TestIds';
export const importReactPlayer = ()=>import('react-player');
export const importYoutubePlayer = ()=>import('react-player/youtube');
export const prefetchPlayers = ()=>{
    void importReactPlayer();
    void importYoutubePlayer();
};
export const GetLazyPlayerTID = (parentTestId)=>getTestIds(parentTestId);
